import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20colorful%20gradient%20with%20soft%20organic%20fruit%20shapes%20in%20warm%20orange%20pink%20and%20green%20tones%2C%20smooth%20flowing%20curves%2C%20modern%20minimal%20design%2C%20artistic%20background%20with%20gentle%20light%20rays%2C%20dreamy%20atmosphere&width=1600&height=900&seq=fairy-hero-bg&orientation=landscape"
        alt="妖精视频"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/60"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-3xl mx-auto text-center px-4">
          <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4 leading-tight">
            妖精视频
            <span className="block text-xl md:text-2xl font-sans font-normal mt-3 text-background-200">
              水果植物系列 · 高清免费在线观看
            </span>
          </h1>
          <p className="text-sm md:text-base text-background-300 max-w-2xl mx-auto mb-8 leading-relaxed">
            汇集香蕉视频、蜜桃视频、西瓜视频、樱花视频等热门平台，电视剧全集不缓冲，最新电影大全一网打尽
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观看
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/30 hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}